import { render, staticRenderFns } from "./InPendingArticlesAndOrdersInternal.vue?vue&type=template&id=25e3fed4&scoped=true"
import script from "./InPendingArticlesAndOrdersInternal.vue?vue&type=script&lang=js"
export * from "./InPendingArticlesAndOrdersInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3fed4",
  null
  
)

export default component.exports